import { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useForm } from 'react-hook-form'
import useServicesHook from '../../../api/services'
import { useLocation  } from 'react-router-dom'

import {
  ViewServices,
  FormServices,
  Message,
} from '../../../components'

const Services = () => {
  const [page, setPage] = useState(1)
  const [id, setId] = useState(null)
  const [edit, setEdit] = useState(false)
  const [q, setQ] = useState('')
  const [service, setService] = useState(null)

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search)
  var licenseId = searchParams.get('license_id')

  const { getServices, deleteService } =
    useServicesHook({
      page,
      q,
    })

  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      auth: true,
    },
  })

  const { data, isLoading, isError, error, refetch } = getServices

  const {
    isLoading: isLoadingDelete,
    isError: isErrorDelete,
    error: errorDelete,
    isSuccess: isSuccessDelete,
    mutateAsync: mutateAsyncDelete,
  } = deleteService


  var formCleanHandler = () => {
    setEdit(false)
    reset()
    setService(null)
  }

  useEffect(() => {
    refetch()
  }, [page])


  useEffect(() => {
    if (!q) refetch()
  }, [q])

  const searchHandler = (e) => {
    e.preventDefault()
    refetch()
    setPage(1)
  }

  const deleteHandler = (id) => {
    mutateAsyncDelete(id)
  }


  const editHandler = (service) => {
    setId(service._id)
    setEdit(true)
    setService(service)
  }

  return (
    <>
      <Helmet>
        <title>Servicios</title>
        <meta property='og:title' content='Servicios' key='title' />
      </Helmet>
      {isSuccessDelete && (
        <Message variant='success'>
          El servicio se ha eliminado correctamente.
        </Message>
      )}
      {isErrorDelete && <Message variant='danger'>{errorDelete}</Message>}


      <FormServices
        edit={edit}
        id={id}
        service={service}
        licenseId={licenseId}
        formCleanHandler={formCleanHandler}
        isLoading={isLoading}
        isError={isError}
        errors={errors}
        register={register}
        handleSubmit={handleSubmit}
        watch={watch}
        error={error}
      />



        <ViewServices
          data={data}
          editHandler={editHandler}
          deleteHandler={deleteHandler}
          isLoadingDelete={isLoadingDelete}
          setQ={setQ}
          q={q}
          searchHandler={searchHandler}
          formCleanHandler={formCleanHandler}
        />
      
    </>
  )
}

export default Services
